const Usdt = () => (
    <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.9543 8.95431 0 20 0C31.0457 0 40 8.9543 40 20ZM22.1319 21.8424V21.8456V21.8488C27.0033 21.6302 30.6399 20.7813 30.6399 19.7652C30.6399 18.7492 27.0065 17.9003 22.1319 17.6816V21C21.9904 21.0128 21.2316 21.0771 19.7139 21.0771C18.4502 21.0771 17.5338 21.0225 17.2155 21V17.6784C12.3344 17.8938 8.68814 18.7459 8.68814 19.762C8.68814 20.7813 12.3312 21.6302 17.2155 21.8456V21.8424C17.5306 21.8585 18.4213 21.8938 19.6914 21.8938C21.2798 21.8938 21.9936 21.852 22.1319 21.8424ZM22.1319 14.3665V17.3376L22.1351 17.3408C27.6528 17.5948 31.8007 18.6913 31.8007 20C31.8007 21.3119 27.6528 22.4051 22.1351 22.6591V32.1832H17.2187V22.6591C11.6946 22.4019 7.53702 21.3086 7.53702 19.9967C7.53702 18.6848 11.6914 17.5916 17.2187 17.3376V14.3665H10.418V9.83597H28.9325V14.3665H22.1319Z'
            fill='white'
        />
    </svg>
);

export default Usdt;
